<nav *ngIf="isVisible" class="mobile-bottom-nav fixed-bottom d-md-none">
  <!-- Sliding pill indicator -->
  <div class="pill-track">
    <div class="pill-indicator" [style.width]="pillWidth" [style.transform]="'translateX(' + pillOffset + '%)'"></div>
  </div>

  <!-- Tab buttons -->
  <div class="tab-container">
    <button
      *ngFor="let tab of tabs"
      class="tab-btn"
      [class.active]="activeTab === tab.key"
      (click)="selectTab(tab.key)"
    >
      <span class="tab-icon-wrap">
        <i class="bi" [ngClass]="tab.icon"></i>
        <span class="tab-badge" *ngIf="getCount(tab.key) > 0">{{ getCount(tab.key) }}</span>
      </span>
      <span class="tab-label">{{ tab.label }}</span>
    </button>
  </div>
</nav>
